import React from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import ActionMenu from '../action_menu';
import ComparisonCommentsPanelButton from '../comparison_comments_panel';
import { useComparisonGrid } from '../providers/comparison_grid';
import { ProjectDocumentComparisonProvider } from '../providers/project_document_comparison';
const DocumentComparisonHeader = () => {
    const { id: documentComparisonId } = useParams();
    const { anchorDoc, comparatorDocs, tagsColumnNames } = useComparisonGrid();
    return React.createElement("div", { className: 'comparison-view-header', "data-testid": 'grid-view-header' },
        React.createElement(ProjectDocumentComparisonProvider, null,
            React.createElement("div", null,
                React.createElement("span", { className: 'page-title', "data-testid": 'grid-view-page-title' }, "Clause Comparison"),
                React.createElement("span", { className: 'comments-button' },
                    React.createElement(ComparisonCommentsPanelButton, null))),
            React.createElement("div", { className: 'nav-toggle' },
                React.createElement(ActionMenu, { anchorDoc: anchorDoc, comparisonDocs: comparatorDocs, tagsColumnNames: tagsColumnNames, documentComparisonId: documentComparisonId }),
                React.createElement("div", { className: 'toggle grid', title: 'Grid Comparison View' },
                    React.createElement("i", { className: 'fas fa-table fa-fw' })),
                React.createElement("div", { className: 'toggle file', title: 'Switch to Document Comparison View' },
                    React.createElement(Link, { to: `/doc-comparison-view/${documentComparisonId}`, "data-testid": 'doc-comparison-link' },
                        React.createElement("i", { className: 'fas fa-file fa-fw' }))))));
};
export default DocumentComparisonHeader;
